/// <reference types="./CodecUtils.d.ts" />
import { EntityStatus } from '@dossierhq/core';
import { assertExhaustive, assertIsDefined } from './AssertUtils.js';
export function resolveEntityStatus(status) {
    switch (status) {
        case 'draft':
            return EntityStatus.draft;
        case 'published':
            return EntityStatus.published;
        case 'modified':
            return EntityStatus.modified;
        case 'withdrawn':
            return EntityStatus.withdrawn;
        case 'archived':
            return EntityStatus.archived;
        default:
            assertExhaustive(status);
    }
}
export function resolveAdminEntityInfo(row) {
    const status = resolveEntityStatus(row.status);
    assertIsDefined(row.name);
    return {
        ...resolveEntityValidity(row.invalid, status),
        authKey: row.auth_key,
        createdAt: new Date(row.created_at),
        name: row.name,
        status,
        type: row.type,
        updatedAt: new Date(row.updated_at),
        updatedBy: row.subjects_uuid,
        version: row.version,
    };
}
export function resolvePublishedEntityInfo(row) {
    const name = row.published_name;
    if (name === null) {
        throw new Error('Unexpected null published name');
    }
    return {
        type: row.type,
        name,
        authKey: row.auth_key,
        createdAt: new Date(row.created_at),
        validPublished: (row.invalid & 2) === 0,
    };
}
export function resolveEntityValidity(invalid, status) {
    return {
        valid: (invalid & 1) === 0,
        validPublished: status === EntityStatus.published || status === EntityStatus.modified
            ? (invalid & 2) === 0
            : null,
    };
}
export function resolveEntityFields(row) {
    return {
        entityFields: {
            schemaVersion: row.schema_version,
            encodeVersion: row.encode_version,
            fields: JSON.parse(row.fields),
        },
    };
}
//# sourceMappingURL=CodecUtils.js.map